import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRightIcon, DownloadIcon, MailIcon } from 'lucide-react';
import { ProfileFrame } from '../components/ProfileFrame';
import { sections } from '../data/sections';
const ease = [0.23, 1, 0.32, 1] as const;
const positioning = [{
  label: 'Seat sought',
  value: 'Chair, Senior Independent Director or Non-Executive Director'
}, {
  label: 'Board context',
  value: 'Manufacturing, defence, materials, mobility and public bodies'
}, {
  label: 'Ownership models',
  value: 'State, private equity, employee trust and institute governance'
}, {
  label: 'Committee readiness',
  value: 'Audit & Risk, Remuneration, Nomination, Employee Benefit Trust'
}];
export function Positioning() {
  return <div data-id="element-239" data-mp="26lb9lona8j81">
      <section className="relative -mx-6 -mt-14 bg-navy px-6 py-16 sm:-mx-10 sm:px-10 lg:-mt-20 lg:py-20" data-id="element-240" data-mp="26kjdmcprwjh8">
        <span aria-hidden="true" className="pointer-events-none absolute inset-0 pattern-grid" data-id="element-241" data-mp="2bmh2pnkuu8i3" />
        <div className="relative grid gap-14 lg:grid-cols-[0.9fr_1.1fr] lg:items-center lg:gap-16" data-id="element-242" data-mp="2en1ap9j83gxh">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease
        }} data-id="element-243" data-mp="2nlv5cucztx8e">
            <ProfileFrame data-id="element-244" data-mp="2ilgul4k0c96o" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.08,
          ease
        }} data-id="element-245" data-mp="2xjizbi2rz0pi">
            <div className="flex items-center gap-3" data-id="element-246" data-mp="36c4i2y6ep7ec">
              <span className="font-serif text-sm text-gold" data-id="element-247" data-mp="36busvct6r49p">04</span>
              <span className="h-px w-8 bg-gold" aria-hidden="true" data-id="element-248" data-mp="32aixsrrjlqu4" />
              <span className="text-[11px] font-semibold uppercase tracking-overline text-gold" data-id="element-249" data-mp="3gak10dva5acr">
                Executive Hero &amp; Board Positioning
              </span>
            </div>

            <h2 className="mt-6 font-serif text-3xl leading-tight text-white sm:text-4xl" data-id="element-250" data-mp="28y1d8ugugw7c">
              Positioned for the board seat where industry, capability and
              governance meet.
            </h2>

            <div className="mt-6 border-l-2 border-gold pl-6" data-id="element-251" data-mp="2hyzith6xlbs1">
              <p className="max-w-xl text-[15px] leading-relaxed text-slate-300" data-id="element-252" data-mp="2hwmsafn3xt3d">
                Sovereign capability, industrial transformation, and resilient
                corporate governance. Elevating board effectiveness across
                complex manufacturing, defence, and public–private sector
                partnerships.
              </p>
            </div>

            <dl className="mt-9 grid gap-px bg-white/10 sm:grid-cols-2" data-id="element-253" data-mp="30qiibe1qy7pb">
              {positioning.map(item => <div key={item.label} className="bg-navy-800 px-6 py-5" data-id="element-254" data-mp="35niorq2idcgy">
                  <dt className="text-[10px] font-semibold uppercase tracking-overline text-slate-500" data-id="element-255" data-mp="16chml21hu0tg">
                    {item.label}
                  </dt>
                  <dd className="mt-2 text-[13px] leading-snug text-slate-200" data-id="element-256" data-mp="13qi12k0qa5q4">
                    {item.value}
                  </dd>
                </div>)}
            </dl>

            <div className="mt-9 flex flex-wrap gap-3" data-id="element-257" data-mp="u0yh1b1a45to">
              <Link to="/value-proposition" className="inline-flex items-center gap-2 whitespace-nowrap bg-gold px-6 py-3.5 text-sm font-semibold text-navy transition-colors duration-150 ease-out hover:bg-gold-dark" data-id="element-258" data-mp="u1hxsof70o64">
                Board Profile &amp; Background
                <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-259" data-mp="1hrc8azc1i0n7" />
              </Link>
              <a href="mailto:janice.m.munday@gmail.com?subject=Executive%20CV%20Request" className="inline-flex items-center gap-2 whitespace-nowrap border border-white/25 px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-150 ease-out hover:border-gold hover:text-gold" data-id="element-260" data-mp="1cpmx9jothmz4">
                <DownloadIcon className="h-4 w-4" aria-hidden="true" data-id="element-261" data-mp="1l7nlnx5gjj6y" />
                Download Executive CV
              </a>
              <Link to="/contact" className="inline-flex items-center gap-2 whitespace-nowrap bg-navy-700 px-6 py-3.5 text-sm font-semibold text-white ring-1 ring-inset ring-white/10 transition-colors duration-150 ease-out hover:bg-navy-600" data-id="element-262" data-mp="1pz5mml7hdjrx">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-263" data-mp="23xlre6ls907f" />
                Contact / Inquiries
              </Link>
            </div>
          </motion.div>
        </div>
      </section>

      <section className="pt-16" aria-labelledby="directory-heading" data-id="element-264" data-mp="1uxqd3swxkp36">
        <div className="flex items-center gap-3" data-id="element-265" data-mp="1uzjht2nzgz8j">
          <span className="h-px w-8 bg-gold" aria-hidden="true" data-id="element-266" data-mp="1yxqy5wejbyj7" />
          <span className="text-[11px] font-semibold uppercase tracking-overline text-gold-dark" data-id="element-267" data-mp="ji9zwkki6f9c">
            Site Directory
          </span>
        </div>
        <h2 id="directory-heading" className="mt-5 font-serif text-2xl leading-tight text-navy sm:text-3xl" data-id="element-268" data-mp="nkycn3cc86bl">
          Ten sections. Each holds its own subject, and nothing else.
        </h2>

        <ul className="mt-10 grid gap-px border border-slate-200 bg-slate-200 sm:grid-cols-2" data-id="element-269" data-mp="b3dr2sq2dl15">
          {sections.map(section => <li key={section.path} className="bg-white" data-id="element-270" data-mp="kyxltbsw6dob">
              <Link to={section.path} className="flex h-full flex-col p-7 transition-colors duration-150 ease-out hover:bg-bone-dim" data-id="element-271" data-mp="kxcr9m6kuuqg">
                <span className="font-serif text-sm text-gold-dark" data-id="element-272" data-mp="3ohqvhdijuid7">
                  {section.index}
                </span>
                <span className="mt-3 font-serif text-lg leading-snug text-navy" data-id="element-273" data-mp="28pojabvihg1">
                  {section.navLabel}
                </span>
                <span className="mt-auto pt-3 text-[13px] leading-relaxed text-slateink-light" data-id="element-274" data-mp="3anhianftthzj">
                  {section.summary}
                </span>
              </Link>
            </li>)}
        </ul>
      </section>
    </div>;
}